
const newModel = () => {
    return {
        thethaoThanhtichId: null,
        ten: null,
        thethaoNhomThanhtichId: null,
        tenThethaoNhomThanhtich: null,
        moTa: null,
        ghiChu: null,
        stt: null,
        enabled: null,
        enabledDisplay: null,
        iocId: null,
        iocEnabled: null,
        iocEnabledDisplay: null,
        iocDateUpdated: null,

        dateCreated: null,
        userCreated: null,
        dateModified: null,
        userModified: null,
        isDeleted: null,
        userDeleted: null,
        dateDeleted: null,
        tenUserCreated: null,
        tenUserModified: null,
        tenUserDeleted: null
    }
}

const newFEModel = () => {
    return {
        thethaoThanhtichId: null,
        thethaoNhomThanhtichId: null,
        ten: null,
        moTa: null,
        ghiChu: null,
        stt: "0",
        enabled: true,
    }
}

const fromJson = (item) => {
    return {
        thethaoThanhtichId: item.thethaoThanhtichId,
        ten: item.ten,
        thethaoNhomThanhtichId: item.thethaoNhomThanhtichId,
        tenThethaoNhomThanhtich: item.tenThethaoNhomThanhtich,
        moTa: item.moTa,
        ghiChu: item.ghiChu,
        stt: item.stt,
        iocId: item.iocId,
        iocEnabled: item.iocEnabled,
        iocDateUpdated: item.iocDateUpdated,
        enabled: item.enabled,
        dateCreated: item.dateCreated,
        userCreated: item.userCreated,
        dateModified: item.dateModified,
        userModified: item.userModified,
        isDeleted: item.isDeleted,
        userDeleted: item.userDeleted,
        dateDeleted: item.dateDeleted,
        tenUserCreated: item.tenUserCreated,
        tenUserModified: item.tenUserModified,
        tenUserDeleted: item.tenUserDeleted
    }
}

const parseModeltoFEModel = (item) => {
    return {
        thethaoThanhtichId: item.thethaoThanhtichId,
        ten: item.ten,
        thethaoNhomThanhtichId: item.thethaoNhomThanhtichId,
        tenThethaoNhomThanhtich: item.tenThethaoNhomThanhtich,
        moTa: item.moTa,
        ghiChu: item.ghiChu,
        stt: item.stt,
        enabled: item.enabled,
        dateCreated: item.dateCreated,
        userCreated: item.userCreated,
        dateModified: item.dateModified,
        userModified: item.userModified,
        isDeleted: item.isDeleted,
        userDeleted: item.userDeleted,
        dateDeleted: item.dateDeleted,
        tenUserCreated: item.tenUserCreated,
        tenUserModified: item.tenUserModified,
        tenUserDeleted: item.tenUserDeleted
    }
}

const errors = () => {
    return {
        thethaoThanhtichId: null,
        ten: null,
        thethaoNhomThanhtichId: null,
        moTa: null,
        ghiChu: null,
        stt: null,
        enabled: null,
    }
}

const newPagingSearchModel = () => {
    return {
        pageNumber: null,
        pageSize: null,
        sort: null,
        ten: null,
        thethaoNhomThanhtichId: null,
        enabled: null,
    }
}

const newSearchModel = () => {
    return {
        ten: null,
        thethaoNhomThanhtichId: null,
        enabled: null,
    }
}

export const thanhTichThiDauTheThaoVHModel = {
    newModel,
    newFEModel,
    parseModeltoFEModel,
    fromJson,
    newPagingSearchModel,
    newSearchModel,
    errors,
}


